import { gql } from "apollo-boost";

const posts = gql`
  query posts($filter: PostFilter!) {
    posts(filter: $filter) {
      total
      items {
        PostId
        Title
        Type
        CreatedAt
        Deleted
        Platform
      }
    }
  }
`;

const post = gql`
  query post($id: String!) {
    post(id: $id) {
      PostId
      Title
      Type
      CreatedAt
    }
  }
`;

const postComments = gql`
  query postComments($filter: PostCommentFilter!) {
    postComments(filter: $filter) {
      total
      items {
        CommentId
        ResourceId
        Comment
        CreatedAt
        createdBy
        Deleted
      }
    }
  }
`;

const delPost = gql`
  mutation delPost($id: String!) {
    delPost(id: $id)
  }
`;

const delPostComment = gql`
  mutation delPostComment($id: String!) {
    delPostComment(id: $id)
  }
`;

export const postGql = {
  posts,
  post,
  postComments,
  delPost,
  delPostComment,
};
